module.exports = __webpack_public_path__ + "media/images/plissees-84f5e8d378dfa0ee84e3147e41a38aff.jpg";